import React from "react";
import styled from "styled-components";

const Botones = ({ children, active }) => {
  return (
    <StyledNavButton $active={active}>
      <span>{children}</span>
    </StyledNavButton>
  );
};

const StyledNavButton = styled.span`
  position: relative;
  display: inline-block;
  font-size: 1.50rem;   /* ¡Más grande! */
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.11em;
  color: ${({ $active }) => ($active ? "#005596" : "#232323")};
  cursor: pointer;
  padding: 0px 6px;
  margin: 0 18px;       /* Separa más los botones */
  transition: color 0.2s;

  &:after {
    content: "";
    display: block;
    position: absolute;
    left: 12px;
    right: 12px;
    bottom: 0px;
    height: 3px;
    background:rgb(150, 67, 0);
    transform: scaleX(0);
    transition: transform 0.23s cubic-bezier(.4,0,.2,1);
    border-radius: 0px;
  }

  &:hover {
    color:rgb(226, 198, 40);
  }

  &:hover:after,
  &.${({ $active }) => $active && "active"}:after {
    transform: scaleX(1);
  }
`;

export default Botones;
